import { makeVar } from '@apollo/client';

export const activatePlanData = makeVar<string | null>(null); // JSON-stringified PlanActivationStoredData
